module.exports = __webpack_public_path__ + "static/img/2_5_1.344c2808.jpg";